import firebase from "firebase";

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyCUrZJnSFpNvrWJJjnJXSBgcnRAeZ7sUoc",
  authDomain: "exposed-7a994.firebaseapp.com",
  databaseURL: "https://exposed-7a994.firebaseio.com",
  projectId: "exposed-7a994",
  storageBucket: "exposed-7a994.appspot.com",
  messagingSenderId: "795418582721",
  appId: "1:795418582721:web:658ce45006a524e1a53e40",
  measurementId: "G-T7VTS4KMDM"
};

/*
apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
databaseURL: process.env.VUE_APP_FIREBASE_DB_URL,
projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
appId: process.env.VUE_APP_FIREBASE_ID,
measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
*/

// Initialize Firebase
export default firebase.initializeApp(firebaseConfig);
